import React, { useState, useMemo, useEffect } from 'react';
import { OptionsType } from '../../utils/customSelectUtils';
import { commonBackInfo, dealwithLanguage } from '../../utils';
import CustomSelect from '../../components/CustomSelect';
import type { SingleCommonType } from '../../types';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { languagePlaceholder } from '../../constants/placeholder';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function VoiceLanguageSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  filterOptions,
  lang,
}: SingleCommonType) {
  // 搜索的数据
  const [searchValue, setSearchValue] = useState('');
  const languageOptions = useMemo(() => {
    let language: { [key: string]: any } = {};
    if (filterOptions) {
      language = filterOptions?.voice_language || filterOptions;
    }
    return language.map((val) => {
      const { language_code, language_name_ch, language_name_en } = val;
      return [language_code, language_name_en, language_name_ch];
    });
  }, [filterOptions]);
  const { formatMessage } = useIntl();

  const options: OptionsType = useMemo(() => {
    // 其实可以不用dealwithLanguage处理为数组，直接使用LanguageOptions进行循环更加节约性能
    // 如果将这类组件整合后，那么这个是值得的。
    return dealwithLanguage(languageOptions, searchValue, lang);
  }, [languageOptions, searchValue, lang]);

  const basicOptions: OptionsType = useMemo(() => {
    return dealwithLanguage(languageOptions, '', lang);
  }, [languageOptions, lang]);

  const {
    selects: selectLanguage,
    setSelects: setSelectLanguage,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'language',
    options: basicOptions?.map((item) => item.value),
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    let language = isAll ? [] : selectLanguage;

    onChange?.('language', commonBackInfo({ language }, { language: text }));
  }, [selectLanguage, formatMessage]);

  return (
    <div className={`language-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={languagePlaceholder[lang]}
        options={options}
        basicOptions={basicOptions}
        searchInfo={[searchValue, setSearchValue]}
        selectOptionsInfo={[selectLanguage, setSelectLanguage]}
        onClear={() => setSelectLanguage([])}
        pointKey={FilterButtonPoint.voiceLanguage}
      ></CustomSelect>
    </div>
  );
}
